import { render, staticRenderFns } from "./FullScreenBannerBox.vue?vue&type=template&id=1bceeee6"
import script from "./FullScreenBannerBox.vue?vue&type=script&lang=js"
export * from "./FullScreenBannerBox.vue?vue&type=script&lang=js"
import style0 from "./FullScreenBannerBox.vue?vue&type=style&index=0&id=1bceeee6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports